import React from 'react'
import Navbar from '../inc/Navbar';
import { Link } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";

import Reviews from './Reviews';
import Develop  from './Develop';
import { Contactformnew } from './ContactfromNew';

function Websitedevelopment() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="Gray" />
            <div className='websitedevelopkrishnagar'>
                <div className="album py-2">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Website Development</li>
                            </ol>
                        </nav>
                    </div>
                </div>

                <br />


                <div className="album py-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7">

                                <h1 className='linetext'><b>Website Development – Fast & Reliable with Expert Support, Trusted by Clients Across India!</b></h1>
                                <p className='mb-2' style={{ color: "grey" }}> Custom, responsive, and SEO-optimized websites designed for performance and user experience.</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg> Static & Dynamic Websites</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg>  E-commerce Development</p>
                                <p className='mb-2' style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg> Portfolio & Business Websites</p>
                                <p style={{ color: "grey" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" style={{ color: "blue" }} height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05" />
                                </svg> Landing Page Design</p>


                            </div>
                            <div className="col-md-5">
                                <Contactformnew/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <br />
                    <h1 className=' mb-0'><b>Website</b> Development Services</h1>
                    <div className="row">
                        <div className="col-md-5 mb-0">
                            <hr className='mb-2 mb-3' />
                        </div>
                    </div>

                    <h5 style={{ color: "#909090" }} className='websitedevelopment mb-3'>
                        Mr. Indian Coder provides professional website development services with a strong focus on performance, responsiveness, and scalability. With satisfied clients across major West Bengal regions—including Krishnagar (Nadia), Berhampore (Murshidabad), Kolkata (New Town), and Kalyani—our results are reflected in both real-time client testimonials and the consistent success of the websites we deliver.</h5>
                    <h5 ><b>🔹 Client Satisfaction Comes First </b></h5>
                    <p className='websitedevelopment'>We are proud to have delivered 120+ successful projects to MSMEs, startups, Public School, Garments Business, Jewellers  Busienss and local businesses. Many of our clients have shared their satisfaction through video reviews — a true reflection of our commitment to quality, support, and result-oriented development.</p>
                    <h5><b> 🔹 Serving Clients Across Cities</b></h5>
                    <p>We have successfully delivered websites for clients across a wide geographic range including:</p>
                    <p> Krishnagar | Berhampore | Polsanda, Nabagram | Karimpur | Tehatta |  Kolkata (New Town) | Kalyani | Ranaghat | Siliguri | Durgapur | Asansol — and expanding!</p>

                    <h5 className='mb-2'><b> 🔹 Our Technology Stack</b></h5>
                    <p className='mb-2'><small>We utilize industry-leading technologies to ensure robust and future-ready website solutions:</small></p>

                    <p className='mb-3'><small>Front-end Development: React.js, Back-end Development: Node.js</small></p>
                    <h5><b> 🔹 Key Features of Our Websites</b></h5>
                    <p><small>Fully Responsive Across All Devices, E-commerce and Payment Gateway Integration, SEO-Optimized for Search Engine Visibility, Fast Load Times (1–2 seconds on average)

                    </small></p>
                </div>
                <br />
                <Develop/>
       
        <div className="album py-0">
                <div className="container">
             <h1 style={{color:"grey"}}> Reviews from Our Hon'ble Clients</h1>
                    </div>
                    </div>
                <Reviews/>
            </div>


        </div>
    )
}

export default Websitedevelopment